import React, { useState, useEffect } from 'react';
import { Globals } from '../../global/Globals';
import DropdownList from '../../components/DropdownList/DropdownList';
import FileUploader from '../../components/FileUploader/FileUploader';
import TextArea from '../../components/TextArea/TextArea';
import RegisterHeader from '../../components/RegisterHeader/RegisterHeader';
import RegisterFooter from '../../components/RegisterFooter/RegisterFooter';
import Popup from '../../components/PopUp/PopUp';
import '../SignUp/Company_reg.css';
import '../multi-lang.css';
import { useDispatch, useSelector } from 'react-redux';
import {
    setAllChannels, setAllGeners, setAllLanguages, setAllCountries, setProvience,
    setSelectedData, removeSelectedData, removeAllData, setAllFormats, setAllProdType
} from '../SignUp/ProducerRegistrationSlice';
import { fetchProvienceByCountry, fetchAllCountries, fetchByfilter, fetchEmail, validateProducerMandatoryFields } from '../../services/GenericAPI';
import { fetchProducer, updateProducer } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import TitledEditDropdown from '../../components/TitledEditDropdown/TitledEditDropdown';
import ConditionalUpload from '../../components/ConditionalUpload/ConditionalUpload';
import { validateEmail, validatePhoneNumber, checkEmailExistance, validateName, validateWebsite, validateSocialMediaLinks } from '../../util/util';
import { removeAllCheck } from '../../components/TermsConditions/TermsConditionsSlice';
import ProgressLoader from '../../components/ProgressLoader/ProgressLoader';
import CryptoUtils from '../../util/cryptoUtils';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const EditCompany = () => {
    const { Globals ,languages, setLanguages } = useLanguage();
    const [isLoading, setIsLoading]=useState(false);
    const [formData, setFormData] = useState({
        producerId: '',
        ProducerType: '',
        companyName: '',
        companyRegNo: '',
        title: '',
        name: '',
        email:"",
        website: '',
        socialMediaLinks: [''],
        vatRegistrationNumber:"",
        isTaxClearanceCertificate: false,
        isApprovedByAuth: true,
        isTermAndCondition: true,
        taxClearanceCertPin:"",
        isBBBEE:false,
        isVendorRegistered:false,
        companyContactNumber:"",
        businessAddress:"",
        companyEmail:"",
        declarationOfInfo:"",
        isApproved:true,
        isActive: false,
        country: "",
        provience:"",
        language:[],
        languages:[],
        channels:[],
        genres:[],
        productionTypes:[],
        producerLanguageRefs: [],
        producerChannelRefs: [],
        producerGenreRefs: [],
        producerProductionTypeRefs: [],
        producerFormat:[],
        formats:[],
        vendorRegistrationNumber: '',
        IsTaxInvoiceorSampleInvoice: null,
        IsRegistrationDocumentsorCertifiedCopyOfID: null,
        IsBankStampedLetterorCancelledCheque: null,
        IsVat103IfNoVatNumberInTcc: null,

    });
    let countriesList = [];
    const [socialLinks, setSocialLinks] = useState(['']);
    const [title, setTitle] = useState(formData.title || '');
    const [address, setAddress] = useState('');
    const [provience, setProvience] = useState('');
    const [country, setCountry] = useState('');
    const [website, setWebSite] = useState('');
    const [isWebsiteInvalid, setIsWebsiteInvalid] = useState(false);
    const [isKeyContactEmailInvalid, setIsKeyContactEmailInvalid] = useState(false);
    const [isCompanyEmailInvalid, setIsCompanyEmailInvalid] = useState(false);
    const [isCompanyPhoneNumInValid, setIsCompanyPhoneNumInValid] = useState(false);
    const [isKeyContactEmailExist, setIsKeyContactEmailExist] = useState(false);
    const [isKeyContactNameInvalid, setIsKeyContactNameInvalid] = useState(false);
    const [isCompanyNameInvalid, setIsCompanyNameInvalid] = useState(false);
     const [isCompanyNameExists, setIsCompanyNameExists] = useState(false); 
    const [isWebSiteInvalid, setIsWebSiteInvalid] = useState(false);
    const [isSocialMediaInvalid, setIsSocialMediaInvalid] = useState([false]);
    const [areTermsAgreed, setTermsAgreed] = useState(false);
    const [countSelection, setCountSelection] = useState('');
    const [provincesList, setProvincesList] = useState([]);
    const [province, setProvince] = useState('');
    const [provicesDetails, setProvicesDetails] = useState([]);
    const [isRegCanceled, setRegCancel] = useState(false);
    const [isRegFailed, setRegFailure] = useState(false);
    const [isVendorRegistered, setVendorRegistered] = useState(false);
    const [isTaxClearance, setIsTaxClearance] = useState(false);
    const [isBBEECompliant, setIsBBEECompliant] = useState(false )
    const [companyName, setCompanyName] = useState(formData.companyName || '');
    const [companyRegNum, setCompanyRegNum] = useState(formData.companyRegNo || '');
    const [keyContactName, setKeyContactName] = useState(formData.name || '');
    const [keyContactEmail, setKeyContactEmail] = useState('');
    const [vatRegNum, setVatRegNum] = useState('');
    const [companyContactNum, setCompanyContactNum] = useState('');
    const [companyEmail, setCompanyEmail] = useState('');
    const [isTitleNotSelected, setTitleNotSelected] = useState(false);
    const [isCompanyRegNumEmpty, setIsCompanyRegNumEmpty] = useState(false);
    const [isCompanyRegNumExists, setIsCompanyRegNumExists] = useState(false);
    const [borderColor, setBorderColor] = useState('');
    const [isCompanyEmailTouched, setIsCompanyEmailTouched] = useState(false);
    const [isKeyContactEmailTouched, setKeyContactEmailTouched] = useState(false);
    const [logoFile, setLogoFile]=useState(null);
    const [taxClrnceCertfile, setTaxClrnceCertfile] = useState(null);
    const [bbbEEfile, setBBBEEfile] = useState(null);
    const allChannelsData = useSelector(state => state.producerRegistration.allChannels);
    const allLanguagesData = useSelector(state => state.producerRegistration.allLanguages);
    const allGenersData = useSelector(state => state.producerRegistration.allGeners);
    const allCountriesDetails = useSelector(state => state.producerRegistration.allCountries);
    const allCountriesData = useSelector(state => state.producerRegistration.allCountries.map(ele => ele.countryName));
    const allFormatsData = useSelector(state => state.producerRegistration.allFormats);
    const allProdTypesData = useSelector(state => state.producerRegistration.allProdTypes);
    const selectedFormatsList = useSelector(state => state.producerRegistration.selectedFormat);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditSuccess, setEditSuccess] = useState(false);
    const [successToast, setSuccessToast] = useState(false);
    const [isEditFailed, setEditFailed] = useState(null); 
    const [isFormEdited, setIsFormEdited] = useState(false);
    const [isEditCanceled, setEditCanceled] = useState(false);
    const [isConfirmUpdatePopupVisible, setIsConfirmUpdatePopupVisible] = useState(false);
    const [isVatRegNumInvalid, setIsVatRegNumInvalid] = useState(false);
    const [isVatRegNumExists, setIsVatRegNumExists] = useState(false)
    const [isVendorRegNum, setIsVendorRegNum] = useState(false);
    const [isVenRegNumExists, setIsVenRegNumExists] = useState(false);
    const [isVenRegNumInvalid, setIsVenRegNumInvalid] = useState(false);
    const [venRegNum, setVenRegNum] = useState('');
    const [isVendorRequired, setIsVendorRequired] = useState(false);
    const [isVendorRegistrationRequired, setIsVendorRegistrationRequired] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [clearVenRegNumError, setClearVenRegNumError] = useState(false);
    const [isApiData, setIsApiData] = useState(false);
    const [producerData, setProducerData] = useState(null);
    const [StoredDocuments, setStoredDocuments]=useState('');
const [logoDetails, setLogoDetails]=useState({name:'', downloadPath:'', type:'image/*'});
const [taxDetails, setTaxDetails]=useState({name:'', downloadPath:'', type:'image/*'});
const [bbbeeDetails, setBBBEEDetails]=useState({name:'', downloadPath:'', type:'image/*'});
    const [vat103, setVat103Details] = useState({ name: '', downloadPath: '', type: 'image/*' });
    const [taxInvoice, setTaxInvoiceDetails] = useState({ name: '', downloadPath: '', type: 'image/*' });
    const [regDocs, setRegDocsDetails] = useState({ name: '', downloadPath: '', type: 'image/*' });
    const [bankStamped, setBankStampedDetails] = useState({ name: '', downloadPath: '', type: 'image/*' });
    const [vat103File, setVat103File] = useState(null);
    const [taxInvoiceFile, setTaxInvoiceFile] = useState(null);
    const [bankStampedFile, setBankStampedFile] = useState(null);
    const [regDocFile, setRegDocFile] = useState(null);
const [isTaxFilePresent, setTaxFilePresent] = useState();
const [isBBBEEFilePresent, setBBBEEFilePresent] = useState();

    const [vendorRegControls, setVendorRegControls] = useState({
        vatCert: null,
        vat103: null,
        taxInvoice: null,
        regDocs: null,
        bbbeeCert: null,
        bankStamped: null
    })
    const handleVendorRegControls = (fieldName, file) => {
        setVendorRegControls((prevState) => ({
            ...prevState,
            [fieldName]: file
        }));
    }


    const handleCancelEdit = () => {
        setEditCanceled(true);
      };

    const fetchProducerData = async () => {
        try {
            const data = await fetchProducer();
            const documents = data?.content?.documents;
            setStoredDocuments(documents);
            const getDocumentDetails = (documentFor) => {
            const document = documents.find(file => file.documentFor === documentFor);
            return document ? { name: document.documentName.trim(), downloadPath: document.documentPath.trim() } : {};
            };
                setBBBEEDetails(getDocumentDetails('PBBBEE'));
            setTaxDetails(getDocumentDetails('PTAXCLR'));
            setLogoDetails(getDocumentDetails('PLOGO'));
            setBankStampedDetails(getDocumentDetails('CBankDoc'));
            setVat103Details(getDocumentDetails('CVatDoc'));
            setTaxInvoiceDetails(getDocumentDetails('CTaxInv'));
            setRegDocsDetails(getDocumentDetails('CRegDoc'));
            const producer = data.content.producer;
            const vendorRegistrationNumber = producer.vendorRegistrationNumber || false;
            setProducerData(producer)
        setIsVendorRequired(vendorRegistrationNumber); 
        setIsVendorRegNum(producer.isVendorRegistered)
        setIsVenRegNumInvalid(false)
        setVenRegNum(producer.vendorRegistrationNumber)
            let socialMediaArray = producer.socialMediaLinks
            ? producer.socialMediaLinks.split(',')
            : [];
        if (socialMediaArray.length === 0) {
            socialMediaArray = [''];
        }
        setSocialLinks(socialMediaArray);
        setIsSocialMediaInvalid(socialMediaArray.map(()=> false));
        setSocialLinks(socialMediaArray); 
            setFormData({
                producerId: producer?.producerId || "",
                producerType: producer?.producerType || "",
                companyName: producer?.companyName,
                companyRegNo: producer?.companyRegNo,
                title: producer?.title,
                name: producer?.name,
                email: producer?.email,
                website: producer?.website,
                companyContactNumber:producer?.companyContactNumber?.trim(),
                businessAddress:producer?.businessAddress,
                companyEmail:producer?.companyEmail,
                vatRegistrationNumber:producer?.vatRegistrationNumber || "",
                isBBBEE: producer?.isBBBEE,
                isVendorRegistered: producer?.isVendorRegistered || false,
                isTaxClearanceCertificate: producer?.isTaxClearanceCertificate,
                producer: producer?.producer,
                languages: data?.content?.languages,
                productionTypes: data?.content?.productionTypes,
                genres: data?.content?.genres,
                formats:data?.content?.formats,
                channels:data?.content?.channels,
                provinceId: producer?.provinceId,
                provinceName: producer?.provinceName,
                countryId: producer?.countryId || producer?.regionId,
                countryName: producer?.countryName,
                producerLanguageRefs: [],
                producerChannelRefs: [],
                producerGenreRefs: [],
                producerProductionTypeRefs: [],
                producerFormat:[],
                socialMediaLinks:data?.content?.socialMediaLinks,
                vendorRegistrationNumber: producer?.vendorRegistrationNumber,
                provience:producer?.provience,
                country:producer?.country,
                IsTaxInvoiceorSampleInvoice: null,
                IsRegistrationDocumentsorCertifiedCopyOfID: null,
                IsBankStampedLetterorCancelledCheque: null,
                IsVat103IfNoVatNumberInTcc: null,
        });     
        } catch (error) {
            console.error('Error fetching producer data:', error);
        }
    }
    useEffect(() => {
        fetchProducerData();
    }, []);

    const confirmUpdateAndCallApi = async () => {
        setIsLoading(true);
        setIsConfirmUpdatePopupVisible(false);
        const updateSuccess = await handleUpdate();
        if (updateSuccess) {
            navigate('/Companyprofile?updatedSuccessfully=true');
        } else {
        setEditFailed(true)
        }
    };
    const checkVatRegNum = async () => {
        const vatRegNumFromForm = formData.vatRegistrationNumber || "";
        if(producerData.vatRegistrationNumber === vatRegNumFromForm) return
        setIsVatRegNumInvalid(false);
    
        try {
            const vatRegNumExists = await validateProducerMandatoryFields(
                Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.VAT_REG_NUM,
                vatRegNumFromForm 
            );
    
            if ((vatRegNumFromForm.length > 0 && vatRegNumFromForm.length < 7) || vatRegNumFromForm.length > 14) {
                setIsVatRegNumInvalid(true);
            } else {
                setIsVatRegNumInvalid(false);
                setIsVatRegNumExists(vatRegNumExists);
            }
        } catch (error) {
            console.error("Error validating VAT registration number:", error);
            setIsVatRegNumInvalid(true);
            setIsVatRegNumExists(false);
        }
    };

      const handleUpdate = async () => {
    if (isVenRegNumInvalid) {
        setEditFailed(Globals.ERROR_MESSAGES.INVALID_REGISTRATION_NO);
        setEditSuccess(false);
        return false;
    }
    if(isVatRegNumInvalid) {
        setEditFailed(Globals.ERROR_MESSAGES.INVALID_VAT_REG_NUM);
        setEditSuccess(false);
        return false;
    }
    if(isCompanyPhoneNumInValid){
        setEditFailed(Globals.ERROR_MESSAGES.INVALID_PHONE_NUMBER);
        setEditSuccess(false);
        return false;
    }
    if(isCompanyEmailInvalid){
        setEditFailed(Globals.ERROR_MESSAGES.REG_INVALID_EMAIL);
        setEditSuccess(false);
        return false;
    }
              const socialMediaString = socialLinks.join(',');
              let finalDocuments;
              let formDataToSend = {
                  ...formData,
                  language: formData.languages,
                  genre: formData.genres,
                  socialMediaLinks: socialMediaString,
                  provience: formData.provinceId,
                  country: formData.countryId,
                  countryName:formData.countryName,
                  provinceName:formData.provinceName,
                };

                if (logoFile || taxClrnceCertfile || bbbEEfile || vat103File || taxInvoiceFile || regDocFile || bankStampedFile) {
                    setEditSuccess(true);
                    const updatedFiles = {};
                    if (logoFile) {
                        updatedFiles.logoFile = logoFile;
                    }
                    if (taxClrnceCertfile) {
                        updatedFiles.taxClrnceCertfile = taxClrnceCertfile;
                    }
                    if (bbbEEfile) {
                        updatedFiles.bbbEEfile = bbbEEfile;
                    }
                    if (vat103File) {
                        updatedFiles.vat103File = vat103File;
                    }
                    if (taxInvoiceFile) {
                        updatedFiles.taxInvoiceFile = taxInvoiceFile;
                    }
                    if (regDocFile) {
                        updatedFiles.regDocFile = regDocFile;
                    }
                    if (bankStampedFile) {
                        updatedFiles.bankStampedFile = bankStampedFile;
                    }
                    
                    if (country === Globals.SOUTH_AFRICA) {
                        finalDocuments = StoredDocuments;
                    }
                    if (country !== Globals.SOUTH_AFRICA) {
                        const nonSADocs = StoredDocuments.filter(doc => doc.documentFor !== 'PBBBEE');
                        finalDocuments = nonSADocs
                    }
                    formDataToSend = {
                        ...formDataToSend,
                        ...updatedFiles,
                        documents: finalDocuments
                    };
                } else {
                    setEditSuccess(false);
                    if (country === Globals.SOUTH_AFRICA) {
                        finalDocuments = StoredDocuments;
                    }
                    if (country !== Globals.SOUTH_AFRICA) {
                        const nonSADocs = StoredDocuments.filter(doc => doc.documentFor !== 'PBBBEE');
                        finalDocuments = nonSADocs
                    }
                    const updatedStoredDocuments=finalDocuments;

                    // const updatedStoredDocuments = StoredDocuments.map(doc => {
                    //     if (doc.documentFor === "PTAXCLR" && !formData.isTaxClearanceCertificate) {
                    //         return null;
                    //     }
                    //     if (doc.documentFor === "PBBBEE" && !formData.isBBBEE) {
                    //         return null;
                    //     }
                    //     return doc;
                    // }).filter(doc => doc !== null);
                
                    formDataToSend = {
                        ...formDataToSend,
                        documents: updatedStoredDocuments
                    };
                }
          formDataToSend['IsVat103IfNoVatNumberInTcc'] = vat103.name ? true : false;
          formDataToSend['IsTaxInvoiceorSampleInvoice'] = taxInvoice.name ? true : false;
          formDataToSend['IsRegistrationDocumentsorCertifiedCopyOfID'] = regDocs.name ? true : false;
          formDataToSend['IsBankStampedLetterorCancelledCheque'] = bankStamped.name ? true : false;
          formDataToSend['TaxClrnceCertfile'] = vendorRegControls.vatCert;
          formDataToSend['BBBEEfile'] = vendorRegControls.bbbeeCert;
          formDataToSend['TaxInvoiceorSampleInvoice'] = vendorRegControls.taxInvoice;
          formDataToSend['RegistrationDocumentsorCertifiedCopyOfID'] = vendorRegControls.regDocs;
          formDataToSend['BankStampedLetterorCancelledCheque'] = vendorRegControls.bankStamped;
          formDataToSend['Vat103IfNoVatNumberInTcc'] = vendorRegControls.vat103;

              try {
                  const apiResponse = await updateProducer(formDataToSend);
                  setIsLoading(false);
                  if (apiResponse && apiResponse.status === 'OK') {
                      setFormData(prevFormData => ({
                          ...prevFormData,
                      }));
                      setEditSuccess(true);
                      setEditFailed(null);
                      CryptoUtils.saveToLocalStorage('fullName', formData.name);
                      CryptoUtils.saveToLocalStorage('companyName', formData.companyName);
                      return true; 
                  } else {
                      console.error("API returned an error:", apiResponse);
                      setEditFailed(apiResponse?.message || "Failed to update producer.");
                      setEditSuccess(false);
                      return false; 
                  }
              } catch (error) {
                setIsLoading(false);
                  console.error("Error updating producer (network or other):", error);
                  setEditFailed("A network or unexpected error occurred.");
                  setEditSuccess(false);
                  return false;
              }
          };

        const navigateToCompanyProfile = () => {
        navigate('/Companyprofile?updatedSucessfully=true');
    };
     
    useEffect(() => {
        if (allLanguagesData || allLanguagesData.length === 0) {
            fetchByfilter(FallBackLabel.FILTER_OPTIONS_NAME.LANGUAGE).then((response) => {
                dispatch(setAllLanguages({ allLanguages: response.data.content["Languages"] }));
            })
        }
        if (allGenersData || allGenersData.length === 0) {
            fetchByfilter(FallBackLabel.FILTER_OPTIONS_NAME.GENRE).then((response) => {
                dispatch(setAllGeners({ allGeners: response.data.content["Genres"] }));
            })
        }
        if (allChannelsData || allChannelsData.length === 0) {
            fetchByfilter(FallBackLabel.FILTER_OPTIONS_NAME.CHANNEL).then((response) => {
                dispatch(setAllChannels({ allChannels: response.data.content["Channels"] }));
            })
        }
        if (allCountriesData || allCountriesData.length === 0) {
            fetchAllCountries().then((response) => {
                dispatch(setAllCountries({ allCountries: response.data.content }));
                countriesList = response.data.content.map(country => country.countryName)
            }).catch((error) => {
                console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
            });
        }

        if (allFormatsData || allFormatsData.length === 0) {
            fetchByfilter(FallBackLabel.FILTER_OPTIONS_NAME.FORMAT).then((response) => {
                dispatch(setAllFormats({ allFormats: response.data.content[FallBackLabel.FILTER_OPTIONS_NAME.FORMAT] }));
            })
        }
        if (allProdTypesData || allProdTypesData.length === 0) {
            fetchByfilter(FallBackLabel.FILTER_OPTIONS_NAME.TYPE).then((response) => {
                dispatch(setAllProdType({ allProdTypes: response.data.content[FallBackLabel.FILTER_OPTIONS_NAME.TYPE] }));
            })
        }
    }, []);


const checkVenRegNum = async () => {
    setIsVenRegNumExists(false);
    setIsVenRegNumInvalid(false);
    

    const venRegNumFromForm = formData.vendorRegistrationNumber || "";

    try {
        const venRegNumExists = await validateProducerMandatoryFields(
            Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.VEN_REG_NUM,
            venRegNumFromForm
        );

        setIsVenRegNumExists(venRegNumExists);
        if (venRegNumFromForm.length === 0 && !isVendorRequired) {
            setIsVenRegNumInvalid(true);
        } else {
            setIsVenRegNumInvalid(false);
        }
    } catch (error) {
        setIsVenRegNumInvalid(true);
        setIsVenRegNumExists(false);
    }
};
const handleTitleSelection = (event) => {
    setTitleNotSelected(false);
    setTitle(event);
    setFormData((prevFormData) => ({
      ...prevFormData,
      title: event,
    }));
  };
        useEffect(() => {
          if (formData.title) {
            setTitle(formData.title);
          }
        }, [formData.title]);
    const handleVendorRegNumber = (val) => {
        setIsVenRegNumExists(false);
        setIsVenRegNumInvalid(false);
        setVenRegNum('');
        setIsVendorRegNum(!val);
    };
    const handleCompanyNameChange = (event) => {
        setIsCompanyNameExists(false);
        setIsCompanyNameInvalid(false);
        const newCompanyName = event.target.value;
        setCompanyName(newCompanyName);
        setFormData((prevFormData) => ({
        ...prevFormData,
        companyName: newCompanyName,
        }));
    };
    useEffect(() => {
        if (formData.companyName) {
        setCompanyName(formData.companyName);
        }
    }, [formData.companyName]);
    const handleCompanyRegNumChange = (event) => {
        setIsCompanyRegNumEmpty(false); setIsCompanyRegNumExists(false);
        const newCompanyRegNum = event.target.value;
        setCompanyRegNum(newCompanyRegNum);
        setFormData((prevFormData) => ({
          ...prevFormData,
          companyRegNo: newCompanyRegNum,
        }));
      };
      useEffect(() => {
        if (formData.companyRegNo) {
          setCompanyRegNum(formData.companyRegNo);
        }
      }, [formData.companyRegNo]);
    const handleKeyContactName = (event) => {
        setIsKeyContactNameInvalid(false);
        const newName = event.target.value;
        checkTitle();
        setKeyContactName(newName);
        setBorderColor('#0B0C0C');
        setFormData((prevFormData) => ({
          ...prevFormData,
          name: newName,
        }));
      }; 
      useEffect(() => {
        if (formData.name) {
            setKeyContactName(formData.name);
        }
      }, [formData.name]);

      const handleKeyContactEmail = (event) => {
        setIsKeyContactEmailExist(false);
        setIsKeyContactEmailInvalid(false);
        setKeyContactEmail(event.target.value);
    }
    const handleVatRegNum = (event) => {
        setIsVatRegNumExists(false);
        setIsVatRegNumInvalid(false);
        setVatRegNum(event.target.value);
        setFormData((prevFormData) => ({
            ...prevFormData,
            vatRegistrationNumber: event.target.value,
        }));
    };
    
    const handleVenRegNum = (event) => {
        setIsVenRegNumExists(false);
        setIsVenRegNumInvalid(false);
        setVenRegNum(event.target.value);
        setFormData((prevFormData) => ({
            ...prevFormData,
            vendorRegistrationNumber: event.target.value,
        }));
    };
    const handleCompanyContactNum = (event) => {
        let phNum = event.target.value.trim();
        phNum = phNum.replace(/[^0-9+]/g, '');
        setFormData(prevFormData => ({
          ...prevFormData,
          companyContactNumber: phNum
        }));
      
        setIsCompanyPhoneNumInValid(phNum.length > 0 ? !validatePhoneNumber(phNum) : false);
        setIsFormEdited(true);
      };
      const handleCompanyEmail = (event) => {
        const email = event.target.value;
        setFormData((prevFormData) => ({
            ...prevFormData,
            companyEmail: email,
        }));
        setIsCompanyEmailInvalid(email.length > 0 ? !validateEmail(email) : false);
        setIsFormEdited(true);
        if (email.length > 0) {
            setBorderColor('#0B0C0C');
        } else {
            setBorderColor('#ccc');
        }
    };
    const handleUpdateOrConfirm = () => {
        setIsConfirmUpdatePopupVisible(true);
    };

    const handleProvince = (selectedProvinceName) => {
        const provinceId = provicesDetails.find(item => item.provinceName === selectedProvinceName)?.provinceId;
    
        if (provinceId) {
            setFormData(prevFormData => ({
                ...prevFormData,
                provinceId: provinceId,
                provinceName: selectedProvinceName,
            }));
            setBorderColor('#0B0C0C');
        } else {
            console.error("Province not found:", selectedProvinceName);
        }
    };
    
    const handleCountry = (selectedCountryName) => {
        const selectedCountry = allCountriesDetails.find(item => item.countryName === selectedCountryName);
        if (selectedCountry) {
            const countryId = selectedCountry.countryId;
                setFormData(prevFormData => ({
                    ...prevFormData,

                    countryId: countryId,
                    countryName: selectedCountryName,
                    provinceId: null,
                    provinceName: null,
                }));
                setBorderColor('#0B0C0C');
                setProvicesDetails([]);
                setProvincesList([]);
    
                fetchProvienceByCountry(allCountriesDetails, selectedCountryName)
                    .then((response) => {
                        const provinces = response.data.content;
                        setProvicesDetails(provinces);
                        setProvincesList(provinces.map(prov => prov.provinceName));
                        dispatch(setProvince({ province: provinces.map(prov => prov.provinceName) }));
                    })
                    .catch((error) => {
                        console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
                    });
            } else {
                console.error("Country not found:", selectedCountryName);
            }
        };

        useEffect(() => {
        if (formData.countryName) {
        fetchProvienceByCountry(allCountriesDetails, formData.countryName)
            .then((response) => {
                const provinces = response.data.content;
                setProvicesDetails(provinces);
                setProvincesList(provinces.map(prov => prov.provinceName));
                dispatch(setProvince({ province: provinces.map(prov => prov.provinceName) }));
            })
            .catch((error) => {
                console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
            });
    }
}, [formData.countryId, allCountriesDetails, dispatch]);
        const handleWebsiteChange = (e, fieldName) => {
            setFormData({
                ...formData,
                [fieldName]: e.target.value,
            });
        
            if (fieldName === 'website') {
                const isValidUrl = (urlString) => {
                    try {
                        return Boolean(new URL(urlString));
                    } catch (e) {
                        return false;
                    }
                };
        
                if (e.target.value.trim() !== "" && !isValidUrl(e.target.value)) {
                    setIsWebsiteInvalid(true);
                } else {
                    setIsWebsiteInvalid(false);
                }
            }
        };
 const handleSocialMedia = (index, link) => {
        const newSocialLinks = [...socialLinks];
        newSocialLinks[index] = link;
        setSocialLinks(newSocialLinks);
        const socialLinksString = newSocialLinks.join(',');
    
        setFormData({
            ...formData,
            socialMediaLinks: socialLinksString, 
        });
    
        checkSocialMedia(index, link);
    };
    
    const addSocialLink = () => {
        const newSocialLinks = [...socialLinks, ''];
        setSocialLinks(newSocialLinks);
        const socialLinksString = newSocialLinks.join(',');
    
        setFormData({
            ...formData,
            socialMediaLinks: socialLinksString, 
        });
    };
    
    const removeSocialLink = (index) => {
        const updatedLinks = socialLinks.filter((_, i) => i !== index);
        setSocialLinks(updatedLinks);
        const updatedInvalidState = [...isSocialMediaInvalid];
        updatedInvalidState.splice(index, 1);
        setIsSocialMediaInvalid(updatedInvalidState);
        const socialLinksString = updatedLinks.join(',');
    
        setFormData({
            ...formData,
            socialMediaLinks: socialLinksString,
        });
    };
    
    const checkSocialMedia = (index, link) => {
        if (link) {
            const isValid = validateSocialMediaLinks(link);
            const updatedInvalidState = [...isSocialMediaInvalid];
            updatedInvalidState[index] = !isValid;
            setIsSocialMediaInvalid(updatedInvalidState);
        } else {
            const updatedInvalidState = [...isSocialMediaInvalid];
            updatedInvalidState[index] = false;
            setIsSocialMediaInvalid(updatedInvalidState);
        }
    };
         
    const handleTaxClearance = (value) => {
        setIsTaxClearance(value);
        setFormData((prevFormData) => ({
        ...prevFormData,
        isTaxClearanceCertificate: value,
        }));
        if (!value) {
        setTaxClrnceCertfile(null);
        setTaxFilePresent(false);
        }
      };
      
      const handleBBEECompliant = (value) => {
        setIsBBEECompliant(value);
        setFormData((prevFormData) => ({
          ...prevFormData,
          isBBBEE: value,
        }));
        if (!value) {
          setBBBEEfile(null);
          setBBBEEFilePresent(false);
        }
      };

    useEffect(() => {
        if (formData.isTaxClearanceCertificate && taxDetails?.name) {
            setTaxFilePresent(true);
        } else if (formData.isTaxClearanceCertificate && !taxDetails?.name) {
            setTaxFilePresent(false);
        } else {
            setTaxFilePresent(undefined);
        }
    }, [formData.isTaxClearanceCertificate, taxDetails]);
      

    useEffect(() => {
    if (formData.isBBBEE && bbbeeDetails?.name) {
        setBBBEEFilePresent(true);
        } else if (formData.isBBBEE && !bbbeeDetails?.name) {
        setBBBEEFilePresent(false);
         } else {
        setBBBEEFilePresent(undefined);
        }
    }, [formData.isBBBEE, bbbeeDetails]);

      const handleFileRemove = (fileType) => {
        if (fileType === 'tax') {
            setTaxClrnceCertfile(null);
            setTaxFilePresent(false);
            setTaxDetails(null)
            setStoredDocuments(prevDocuments =>
                prevDocuments.filter(doc => doc.documentFor !== 'PTAXCLR')
            );
        } else if (fileType === 'bbbee') {
            setBBBEEfile(null);
            setBBBEEFilePresent(false);
            setBBBEEDetails(null)
            setStoredDocuments(prevDocuments =>
                prevDocuments.filter(doc => doc.documentFor !== 'PBBBEE')
            );
        } else if (fileType === 'logo') {
            setLogoFile(null);
            setStoredDocuments(prevDocuments =>
                prevDocuments.filter(doc => doc.documentFor !== 'PLOGO')
            );
        }
        else if (fileType === 'vat103') {
            setVat103File(null);
            setStoredDocuments(prevDocuments =>
                prevDocuments.filter(doc => doc.documentFor !== 'CVatDoc')
            );
        }
        else if (fileType === 'taxInvoice') {
            setTaxInvoiceFile(null);
            setStoredDocuments(prevDocuments =>
                prevDocuments.filter(doc => doc.documentFor !== 'CTaxInv')
            );
        }
        else if (fileType === 'regDocs') {
            setRegDocFile(null);
            setStoredDocuments(prevDocuments =>
                prevDocuments.filter(doc => doc.documentFor !== 'CRegDoc')
            );
        }
        else if (fileType === 'bankStamped') {
            setBankStampedFile(null);
            setStoredDocuments(prevDocuments =>
                prevDocuments.filter(doc => doc.documentFor !== 'CBankDoc')
            );
        }
        
    };
    
    const handleVendorReg = (value) => {
        if (!value && formData.vendorRegistrationNumber) {
            setClearVenRegNumError(true);
        } else {
            setClearVenRegNumError(false);
            setFormData((prevFormData) => ({
                ...prevFormData,
                isVendorRegistered: value,
            }));
        }
    };
    
    const checkForEmail = () => {
        setKeyContactEmailTouched(true);
        setIsKeyContactEmailExist(false);
        setIsKeyContactEmailInvalid(false);
        if (keyContactEmail.length === 0) {
            setIsKeyContactEmailExist(false);
            setIsKeyContactEmailInvalid(true);
        }
        else {
            const regex = Globals.REGEX.EMAIL_REGEX;
            const isValid = regex.test(keyContactEmail);
            if (isValid) {
                fetchEmail(keyContactEmail).then((response) => {
                    response.data.exists ? setIsKeyContactEmailExist(true) : setIsKeyContactEmailExist(false);
                }).catch((error) => { console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error) })
            }
            else {
                setIsKeyContactEmailInvalid(!isValid);
            }
        }
    }

    const checkKeyName = () => {
        keyContactName.length>0 ? setIsKeyContactNameInvalid(false) : setIsKeyContactNameInvalid(true);
    }

    const checkCompanyName = async () => {
        setIsCompanyNameInvalid(false);
        const isValid = validateName(companyName);
        if (isValid) {
            setIsCompanyNameInvalid(false);
        } else {
            setIsCompanyNameInvalid(true);
        }

        setIsCompanyNameExists(false);
        const response = await validateProducerMandatoryFields(Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.COMPANY_NAME, companyName)
        if (isValid && response) {
            setIsCompanyNameInvalid(false);
            setIsCompanyNameExists(true);
        }
        else if(!isValid){
            setIsCompanyNameInvalid(true);
            setIsCompanyNameExists(false);
        }
            else {
            setIsCompanyNameInvalid(false);
            setIsCompanyNameExists(false);
        }
    };

    const checkForEmptyNumber = () => {
        if (formData.companyContactNumber && formData.companyContactNumber.trim() === "") {
          setIsCompanyPhoneNumInValid(true);
        } else {
          const res = validatePhoneNumber(formData.companyContactNumber);
          setIsCompanyPhoneNumInValid(!res);
        }
      };
      const checkCompanyRegNum = async () => {
        setIsCompanyRegNumEmpty(false);
        setIsCompanyRegNumExists(false);
      
        if (companyRegNum.length === 0) {
          setIsCompanyRegNumEmpty(true);
          return;
        }
      
        if (companyRegNum.length < 7 || companyRegNum.length > 20) {
          setIsCompanyRegNumEmpty(true);
          return;
        }
      
        try {
          const response = await validateProducerMandatoryFields(
            Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.COMPANY_REG_NUM,
            companyRegNum
          );
      
          if (response) {
            setIsCompanyRegNumExists(true);
          } else {
            setIsCompanyRegNumExists(false);
          }
        } catch (error) {
          setIsCompanyRegNumExists(false);
          setIsCompanyRegNumEmpty(false);
        }
      };
    const checkTitle = () => { title.trim() === "" ? setTitleNotSelected(true) : setTitleNotSelected(false); }

    const handleProductionTypeValues = (selectedProductionTypeObjects) => {
        if (!Array.isArray(selectedProductionTypeObjects)) {
            console.error("selectedProductionTypeObjects is not an array:", selectedProductionTypeObjects);
            return;
        }
        const updatedProdTypes = selectedProductionTypeObjects.map(productionType => ({
            productionTypeId: productionType.id,
            productionTypeName: productionType.name
        }));
        setFormData((prevFormData) => ({ ...prevFormData, productionTypes: updatedProdTypes }));
    };

    const selectProductionTypes = allProdTypesData.filter((prod) => {
        if (formData.productionTypes && Array.isArray(formData.productionTypes)) {
            return formData.productionTypes.some((response) => response.productionTypeId === prod.id);
        } else {
            return false;
        }
    });
    const handleSelectAllProdTypes = (e) => {
        setFormData((prevFormData) => {
            if (e) {
                return {
                    ...prevFormData,
                    productionTypes: allProdTypesData.map(item => ({
                        productionTypeId: item.id,
                        productionTypeName: item.name
                    }))
                };
            } else {
                return {
                    ...prevFormData,
                    productionTypes: []
                };
            }
        });
    };
    const handleSelectedChannelsValues = (selectedChannelObjects) => {
        if (!Array.isArray(selectedChannelObjects)) {
            console.error("selectedChannelObjects is not an array:", selectedChannelObjects);
            return;
        }
        const updatedChannels = selectedChannelObjects.map(channel => ({
            channelId: channel.id,
            channelName: channel.name
        }));
        setFormData((prevFormData) => ({ ...prevFormData, channels: updatedChannels }));
    };

    const handleSelectAllChannels = (e) => {
        if (e) {
            setFormData((prevFormData) => ({...prevFormData, channels: allChannelsData.map(item => ({channelId: item.id, channelName: item.name}))}));
        } else {
            setFormData((prevFormData) => ({...prevFormData, channels: []}));
        }
    };
    const selectChannels = allChannelsData.filter((channel) => {
        if (formData.channels && Array.isArray(formData.channels)) {
            return formData.channels.some((response) => response.channelId === channel.id);
        } else {
            return false;
        }
    });
    const handleGenreValues = (selectedGenreObjects) => {
        if (!Array.isArray(selectedGenreObjects)) {
            console.error("selectedGenreObjects is not an array:", selectedGenreObjects);
            return;
        }
        const updatedGenres = selectedGenreObjects.map(genre => ({
            genreId: genre.id,
            genreName: genre.name,
        }));
        setFormData((prevFormData) => ({ ...prevFormData, genres: updatedGenres })); 
    };
    
    const selectGenres = allGenersData.filter((genre) => {
        if (formData.genres && Array.isArray(formData.genres)) {
            return formData.genres.some((response) => response.genreId === genre.id);
        } else {
            return false;
        }
    });
    
    const handleSelectAllGenres = (e) => {
        if (e) {
            setFormData((prevFormData) => ({ ...prevFormData, genres: allGenersData.map(item => ({ genreId: item.id, genreName: item.name })) }));
        } else {
            setFormData((prevFormData) => ({ ...prevFormData, genres: [] })); 
        }
    };
    const handleSelectedFormatValues = (selectedFormatObjects) => {
        if (!Array.isArray(selectedFormatObjects)) {
            console.error("selectedFormatObjects is not an array:", selectedFormatObjects);
            return;
        }
        const updatedFormats = selectedFormatObjects.map(format => ({
            formatId: format.id,
            formatName: format.name,
        }));
        setFormData((prevFormData) => ({ ...prevFormData, formats: updatedFormats }));
    };
    
    const selectFormat = allFormatsData.filter((format) => {
        if (formData.formats && Array.isArray(formData.formats)) {
            return formData.formats.some((response) => response.formatId === format.id);
        } else {
            return false;
        }
    });
    
    const handleSelectAllFormats = (e) => {
        if (e) {
            setFormData((prevFormData) => ({ ...prevFormData, formats: allFormatsData.map(item => ({ formatId: item.id, formatName: item.name })) }));
        } else {
            setFormData((prevFormData) => ({ ...prevFormData, formats: [] }));
        }
    };
    const handleSelectedLanguageValues = (selectedLanguageObjects) => {
        if (!Array.isArray(selectedLanguageObjects)) {
            console.error("selectedLanguageObjects is not an array:", selectedLanguageObjects);
            return;
        }
        const updatedLanguages = selectedLanguageObjects.map(language => ({
            languageId: language.id,
            languageName: language.name,
        }));
        setFormData((prevFormData) => ({ ...prevFormData, languages: updatedLanguages }));
    };
    
    const handleSelectAllLanguages = (e) => {
        if (e) {
            setFormData((prevFormData) => ({ ...prevFormData, languages: allLanguagesData.map(item => ({ languageId: item.id, languageName: item.name })) })); 
        } else {
            setFormData((prevFormData) => ({ ...prevFormData, languages: [] }));
        }
    };
    
    const selectLang = allLanguagesData.filter((language) => {
        if (formData.languages && Array.isArray(formData.languages)) {
            return formData.languages.some((response) => response.languageId === language.id);
        } else {
            return false;
        }
    });

    const handleLogoFileInput=(file)=>{
        setLogoFile(file);
    }
    const handleTaxCertificateFileInput = (file) => {
        setTaxClrnceCertfile(file);
        setTaxFilePresent(true);
    }

    const handleBBEEEFileInput = (file) => {
        setBBBEEfile(file);
        setBBBEEFilePresent(true);
    }
    const isFormValid =
        title.trim() !== '' &&
        companyName.trim() !== '' &&
        companyRegNum.trim() !== '' &&
        keyContactName.trim() !== '' &&
        !isVatRegNumExists &&
        ((isVendorRegNum  && (venRegNum?.trim() || formData.vendorRegistrationNumber?.trim())) || !isVendorRegNum) &&
        !isCompanyRegNumExists &&
        !isCompanyNameExists &&
        !isCompanyRegNumEmpty &&
        isSocialMediaInvalid.every(value => value === false) &&
        !isWebSiteInvalid &&
        !isCompanyNameInvalid &&
        !isTitleNotSelected &&
        !isKeyContactEmailInvalid &&
        !isKeyContactNameInvalid &&
        !isCompanyPhoneNumInValid &&
        !isCompanyEmailInvalid &&
        //(isTaxFilePresent!==false)&&
        //(isBBBEEFilePresent!==false)&&
        ((isVendorRegistered && venRegNum.length>0)||!isVendorRegistered);
    return (
        <div id="register-container-edit" className="register-container-edit">
            <RegisterHeader onCancelRegister={handleCancelEdit} title={Globals.SIGNUP.EDIT_COMPANY} />
            <div id="register-form-edit" className="register-form-edit">
                <div id="register-form-content-edit" className="register-form-content-edit">
                    <h3 id="basic-info-edit" className="basic-info-edit">{Globals.SIGNUP.COMPANY_INFO}</h3>
                    <div id="row-content-edit" className="row-1-content-edit">
                   <div id="company-name-holder-edit">
                             <label id="company-name-edit" className="company-name-edit">{Globals.SIGNUP.COMPANY_NAME_LABEL}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                             <input type="text" id="company-name-inp-edit" className={`company-name-inp ${companyName && companyName.length > 0 ? "hightlight-edit" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_NAME} onChange={handleCompanyNameChange} tabIndex={1} onBlur={checkCompanyName} maxLength={30} value={companyName} autoComplete='off'></input>
                            { (isCompanyNameInvalid || isCompanyNameExists) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{companyName.length===0?Globals.ERROR_MESSAGES.EMPTY_COMPANY_NAME : Globals.ERROR_MESSAGES.COMPANY_NAME_EXISTS}</label></div>}
                         </div>
                       <div id="company-reg-num-holder-edit">
                              <label id="company-reg-num-edit" className="company-reg-num-edit">{Globals.SIGNUP.COMPANY_REG_NUMBER_LABEL}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                              <input type="text" id="company-reg-num-inp-edit" className={`company-reg-num-inp-edit ${companyRegNum && companyRegNum.length > 0 ? "hightlight-edit" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_REG_NUMBER} onChange={handleCompanyRegNumChange} onBlur={checkCompanyRegNum} tabIndex={2} maxLength={20} minLength={7} value={companyRegNum} autoComplete='off'></input>
                              {(isCompanyRegNumEmpty || isCompanyRegNumExists) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{(companyRegNum.length === 0) ? Globals.ERROR_MESSAGES.EMPTY_COMPANY_REG_NO : companyRegNum.length>0 && companyRegNum.length <7 ?Globals.ERROR_MESSAGES.INVALID_COMPANY_REG_NO:
                              Globals.ERROR_MESSAGES.COMPANY_REG_NUM_EXISTS}</label></div>}
                          </div>
                        <div id="company-logo-pic-holder-edit">
                            <label id="company-logo-pic-edit" className="company-logo-pic-edit">{Globals.SIGNUP.COMPANY_LOGO_LABEL}</label>
                            <span tabIndex={3}><FileUploader onFileUpload={(file)=>handleLogoFileInput(file)} supportedFileType="ImagesOnly" isPreloadedFile={logoDetails?.name?true:false} preDefinedFile={logoDetails} isFromRegPage={true} onFileRemove={() => handleFileRemove('logo')} isLogoHolder={true}/></span>
                        </div>
                    </div>
                    <div id="row-content-edit" className="row-1-content-edit">
                        <div id="title-holder-edit">
                            <label id="user-title-edit" className="user-title-edit">{Globals.SIGNUP.TITLE}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                            <span tabIndex={4} onBlur={checkTitle}><DropdownList options={Globals.SIGNUP.TITLES_LIST} placeHolderValue={Globals.SIGNUP.TITLES_INP_PLACEHOLDER} onSelect={handleTitleSelection} selectClass={formData.title && "hightlight-edit-title"} selectedValues={formData.title}/></span>
                            {isTitleNotSelected && <div></div>}
                        </div>
                        <div id="name-holder-edit">
                     <label id="name-edit">{Globals.SIGNUP.NAME}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                     <input type="text" id="name-inp-edit" className={`name-inp ${keyContactName && keyContactName.length > 0 ? "hightlight-edit" : ""}`} placeholder={Globals.SIGNUP.NAME_INP_PLACEHOLDER} onChange={handleKeyContactName}
            onBlur={checkKeyName} tabIndex={2} maxLength={30} value={keyContactName} autoComplete='off'/>
            {isKeyContactNameInvalid && (<div><img id="login-error-edit" className="login-error-edit" src={Globals.IMG.ERROR} alt="password error"/>
            <label className="invalidCredential">{keyContactName.trim().length === 0 ? Globals.ERROR_MESSAGES.EMPTY_NAME: Globals.ERROR_MESSAGES.INVALID_NAME}</label></div>)}
            </div>
                        <div id="email-holder-edit">
                        <label id="email-edit" className="email-edit">{Globals.SIGNUP.KEY_CONTACT_MAIL_LABEL}<span id="mandatory-edit" className="mandatory-edit">{Globals.MANDATORY_FIELD}</span></label>
                        <input id="website-inp-edit hightlight-edit" className='company-default-edit' placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.KEY_CONTACT_MAIL} onChange={handleKeyContactEmail} onBlur={checkForEmail} tabIndex={6} value={formData.email} disabled={true} autoComplete='off'></input>
                            {(isKeyContactEmailExist || isKeyContactEmailInvalid)}
                        </div>
                    </div>
                    <div id='website-holder'>
    <label id="website-edit" className="website-edit">{Globals.SIGNUP.WEBSITE}</label>
    <input
        type="url"
        id="website-inp-edit"
        className={`website-inp-edit ${formData.website && formData.website.trim() !== "" ? "hightlight-edit" : ""}`}
        placeholder={Globals.SIGNUP.WEBSITE_PLACEHOLDER}
        onChange={(e) => handleWebsiteChange(e, 'website')}
        tabIndex={9}
        value={formData.website}
    />
</div>
                   <div id="social-media-holder-edit">
                       <label id="social-media-edit" className="social-media-edit">{Globals.SIGNUP.SOCIAL_MEDIA}</label>
                       {socialLinks.map((link, index) => (
                           <div className="reg-social-media-default-inp-edit" style={{ display: 'flex' }} key={index}>
                               <div id="social-media-section" className="social-media-section-edit">
                                   <input
                                       key={`social-link-${index}`}
                                       value={socialLinks[index] || ''} 
                                       type="url"
                                       id="social-media-inp-edit"
                                       className={`social-media-inp-edit ${socialLinks[index] && socialLinks[index].length > 0 ? "hightlight-edit" : ""}`}
                                       placeholder={Globals.SIGNUP.SOCIAL_MEDIA_PLACEHOLDER}
                                       onChange={(event) => handleSocialMedia(index, event.target.value)} 
                                   />
                               </div>
                               {index > 0 && (
                                   <button
                                       type="button"
                                       className="remove-social-link-edit"
                                       onClick={() => removeSocialLink(index)}
                                   />
                               )}
                           </div>
                       ))}
                       {socialLinks.length < 3 ? (
                           <button
                               type="button"
                               id="reg-comp-add-social-link-edit"
                               className={`${localStorage.getItem('lang')!=='en' ?"add-more-links":"reg-comp-add-social-link-edit"}`}
                               onClick={addSocialLink}
                           >
                               {Globals.SIGNUP.ADD_MORE_LINKS}
                           </button>
                       ) : (
                           <button
                               type="button"
                               id="reg-comp-add-social-link-disabled-edit"
                               className="reg-comp-add-social-link-disabled-edit"
                               disabled={true}
                           >
                               {Globals.SIGNUP.ADD_MORE_LINKS}
                           </button>
                       )}
                   </div>
                    <div id="row-content-edit" className="row-1-content-edit">
                    <div id="genre-holder-edit">
    <label id="genre-edit" className="genre-edit">{Globals.SIGNUP.GENRE}</label>
    <span tabIndex={8}>
        <TitledEditDropdown
            title={Globals.SIGNUP.GENRE_PLACEHOLDER}
            options={allGenersData}
            onSelectAll={handleSelectAllGenres}
            onSelect={handleGenreValues}
            selectedValues={selectGenres}
            selectClass={selectGenres.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
</div>
       <div id="language-holder-edit">
    <label id="language-edit" className="language-edit">{Globals.SIGNUP.LANGUAGE}</label>
    <span tabIndex={9}>
        <TitledEditDropdown
            title={Globals.SIGNUP.LANGUAGE_PLACEHOLDER}
            options={allLanguagesData}
            onSelectAll={handleSelectAllLanguages}
            onSelect={handleSelectedLanguageValues}
            selectedValues={selectLang}
            selectClass={selectLang.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
</div>
    <div id="format-holder-edit">
    <label id="format-edit" className="format-edit">{Globals.SIGNUP.FORMAT_LABEL}</label>
    <span tabIndex={10}>
        <TitledEditDropdown
            title={Globals.SIGNUP.COMPANY_PLACEHOLDERS.FORMAT}
            options={allFormatsData}
            onSelectAll={handleSelectAllFormats}
            onSelect={handleSelectedFormatValues}
            selectedValues={selectFormat}
            selectClass={selectFormat.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
</div>
                    </div>
                    <div id="row-content-edit" className="row-1-content-edit">
                        <div id="production-type-holder-edit">
                            <label id="production-type-edit" className="production-type-edit">{Globals.SIGNUP.PRODUCTION_TYPE_LABEL}</label>
                            <span tabIndex={11}>
                    <TitledEditDropdown
                        title={Globals.SIGNUP.COMPANY_PLACEHOLDERS.PRODUCTION_TYPE}
                        options={allProdTypesData}
                        onSelectAll={handleSelectAllProdTypes}
                        onSelect={handleProductionTypeValues}
                        selectedValues={selectProductionTypes}
                        selectClass={selectProductionTypes.length > 0 ? "hightlight-edit" : ""}
                    />
                </span>                </div>            
                <div id="channels-holder-edit">
                            <label id="channels-edit" className="channels-edit">{Globals.SIGNUP.CHANNELS}</label>
                            <span tabIndex={12}><TitledEditDropdown
                                title={Globals.SIGNUP.CHANNELS_PLACEHOLDER}
                                options={allChannelsData}
                                onSelectAll={handleSelectAllChannels}
                                onSelect={handleSelectedChannelsValues}
                                selectedValues={selectChannels}
                                selectClass={selectChannels.length > 0 ? "hightlight-edit" : ""}
                            /></span>
                        </div>
                    </div>
                    <div className="seperator-edit"></div>
                    <div>
                        <h3 id="basic-info" className="basic-info-edit">{Globals.SIGNUP.SATUTORY_INFO_LABEL}</h3>
                    </div>

                        <div id="row-content-edit" className="row-1-content-edit">
                        {/* <div id="vat-reg-num-holder-edit">
                            <label id="vat-reg-num-edit" className="vat-reg-num-edit">{Globals.SIGNUP.VAT_REG_NUM_LABEL}</label>
                            <input tabIndex={13} type="text" id="vat-reg-num-inp-edit" className={`vat-reg-num-inp-edit ${formData.vatRegistrationNumber && formData.vatRegistrationNumber.length > 0 ? "hightlight-edit" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.VAT_REG_NUM} onChange={handleVatRegNum} onBlur={checkVatRegNum} maxLength={14} value={formData.vatRegistrationNumber} autoComplete='off'></input>
                            {(isVatRegNumInvalid || isVatRegNumExists) && <div><img id="login-error" className="login-error-edit" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{isVatRegNumInvalid?Globals.ERROR_MESSAGES.INVALID_VAT_REG_NUM:Globals.ERROR_MESSAGES.VAT_REG_NUM_EXISTS}</label></div>}
                        </div> */}
                        <div id="vendor-reg-holder">
                            <label id="vendor-reg" className="vendor-reg">{Globals.SIGNUP.VENDOR_REQUIRED}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span><ConditionalUpload disableToggle={!producerData?.vendorRegistrationNumber} inputValue={isVendorRegNum} isUploadRequired={false} setOption={handleVendorReg} tabIndex1={14} tabIndex2={15} handleVendorRegNum={handleVendorRegNumber} /></span>
                        </div>
                        {isVendorRegNum && <div id="ven-reg-num-holder">
                            <label id="ven-reg-num" className="ven-reg-num">{Globals.SIGNUP.VEN_REG_NUM_LABEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input disabled={producerData?.vendorRegistrationNumber} type="text" id="ven-reg-num-inp" className={`ven-reg-num-inp ${venRegNum && venRegNum.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.VEN_REG_NUM} onChange={handleVenRegNum} onBlur={checkVenRegNum} onLoad={checkVenRegNum} maxLength={30} value={formData.vendorRegistrationNumber || ''} autoComplete='off'></input>
                            {(!venRegNum?.trim() && !formData.vendorRegistrationNumber?.trim()) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.EMPTY_COMPANY_VENDOR_REG_NUM}</label></div>}
                            {(!venRegNum?.trim() && isVenRegNumExists) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.VENDOR_REG_NUM_EXISTS}</label></div>}
                        </div>}
                    </div>
                    <div id="row-content" className="row-1-content">
                        {!isVendorRegNum && (
                            <>
                                <div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_CLEARANCE_CERTIFICATE}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('vatCert',file)} onFileRemove={() => handleFileRemove('vatCert')} supportedFileType="All" isFromRegPage={true} isPreloadedFile={taxDetails?.name?true:false} preDefinedFile={taxDetails}/>
                                    </div>
                                </div>
                                <div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_103}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('vat103',file)} onFileRemove={() => handleFileRemove('vat103')} supportedFileType="All" isFromRegPage={true} isPreloadedFile={vat103?.name?true:false} preDefinedFile={vat103} />
                                    </div>
                                </div>
                                <div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.TAX_INVOICE}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('taxInvoice',file)} onFileRemove={() => handleFileRemove('taxInvoice')} supportedFileType="All" isFromRegPage={true} isPreloadedFile={taxInvoice?.name?true:false} preDefinedFile={taxInvoice}/>
                                    </div>
                                </div>
                            </>
                            )}
                    </div>
                    <div id="row-content" className="row-1-content">
                        {!isVendorRegNum && (
                            <>
                                <div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.REG_DOCS}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('regDocs',file)} onFileRemove={() => handleFileRemove('regDocs')} supportedFileType="All" isFromRegPage={true} isPreloadedFile={regDocs?.name?true:false} preDefinedFile={regDocs}/>
                                    </div>
                                </div>
                                {(formData.countryName===Globals.SOUTH_AFRICA || formData.countryName===FallBackLabel.SOUTH_AFRICA)&&<div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VALID_BBEEE_CERTIFICATE}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('bbbeeCert',file)} onFileRemove={() => handleFileRemove('bbbeeCert')} supportedFileType="All" isFromRegPage={true} isPreloadedFile={bbbeeDetails?.name?true:false} preDefinedFile={bbbeeDetails}/>
                                    </div>
                                </div>}
                                <div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.BANK_STAMPED}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('bankStamped',file)} onFileRemove={() => handleFileRemove('bankStamped')} supportedFileType="All" isFromRegPage={true} isPreloadedFile={bankStamped?.name?true:false} preDefinedFile={bankStamped}/>
                                    </div>
                                </div>
                            </>
                            )}
                    </div>

                        {/* <div id="row-content-edit" className="row-1-content-edit">
                        <div id="tax-clearance-holder-edit" className="tax-clearance-holder-edit">
                            <label id="tax-clearance-ques-edit" className="tax-clearance-ques-edit">{Globals.SIGNUP.TAX_CERTIFICATE_QUESTION_LABEL}</label>
                            <span><ConditionalUpload isUploadRequired={true} setOption={handleTaxClearance} tabIndex1={16} tabIndex2={17} inputValue={formData.isTaxClearanceCertificate}/></span>
                            </div>
                           <div id="upload-question-holder-edit" className="upload-question-holder-edit">
                            {formData.isTaxClearanceCertificate && (
                                <div>
                                    <label key={formData.isTaxClearanceCertificate} id="upload-question-edit" className="upload-question-edit">{Globals.SIGNUP.PLEASE_UPLOAD}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file)=>handleTaxCertificateFileInput(file)} supportedFileType="pdfOrDocOnly" isPreloadedFile={taxDetails?.name?true:false} preDefinedFile={taxDetails} isFromRegPage={true} onFileRemove={() => handleFileRemove('tax')} />
                                        {(isTaxFilePresent===false)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.EMPTY_TAX_FILE}</label></div>}
                                    </div>
                                </div>
                            )}                        
                            </div>
                        </div> */}
                        {/* <div id="row-content-edit" className="row-1-content-edit">
                        <div id="bbee-compliant-holder-edit" className="bbee-compliant-holder-edit">
                            <label id="bbee-compliant-ques-edit" className="bbee-compliant-ques-edit">{Globals.SIGNUP.BBEE_COMPLIANT_LABEL}</label>
                            <span><ConditionalUpload isUploadRequired={true} setOption={handleBBEECompliant} tabIndex1={18} tabIndex2={19} inputValue={formData.isBBBEE}/></span>
                        </div>
                        <div id="upload-question-holder bbee-question-edit" className="upload-question-holder bbee-question-edit">
                            {formData.isBBBEE && (
                                <div>
                                    <label key={formData.isBBBEE} id="upload-question" className="upload-question-edit">{Globals.SIGNUP.PLEASE_UPLOAD}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleBBEEEFileInput(file)} supportedFileType="pdfOrDocOnly" isPreloadedFile={bbbeeDetails?.name?true:false} preDefinedFile={bbbeeDetails} isFromRegPage={true} onFileRemove={() => handleFileRemove('bbbee')}
                                        />
                                        {(isBBBEEFilePresent===false)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.EMPTY_BBEE_FILE}</label></div>}
                                    </div>
                                </div>
                            )}                        </div>
                    </div> */}
                    <div className="seperator-edit"></div>
                    <div>
                        <h3 id="basic-info" className="basic-info-edit">{Globals.SIGNUP.CONTACT_INFO_LABEL}</h3>
                    </div>
                    <div id="row-content" className="row-1-content-edit">
                    <div id="phone-number-holder-edit">
    <label id="phone-number-edit" className="phone-number-edit">{Globals.SIGNUP.COMPANY_CONTACT_NUM_LABEL}</label>
    <input
        tabIndex={20}
        type="tel"
        pattern="[0-9+]+"
        id="phone-number-inp-edit"
        className={`phone-number-inp-edit ${formData.companyContactNumber && formData.companyContactNumber.trim().length > 0 ? "hightlight-edit" : ""}`}
        placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_CONTACT_NUM}
        onChange={handleCompanyContactNum}
        onBlur={checkForEmptyNumber}
        value={formData.companyContactNumber}
    />
    {isCompanyPhoneNumInValid && formData.companyContactNumber && formData.companyContactNumber.length > 0 && (
        <div>
            <img id="login-error-edit" className="login-error-edit" src={Globals.IMG.ERROR} alt="password error" />
            <label className="invalidCredential">{Globals.ERROR_MESSAGES.INVALID_PHONE_NUMBER}</label>
        </div>
    )}
</div>
    <div id="email-holder-edit">
    <label id="email-edit" className="email-edit">{Globals.SIGNUP.COMPANY_EMAIL_LABEL}</label>
    <input
        tabIndex={21}
        type="text"
        id="email-input-edit"
        className={`email-input-edit ${formData.email && formData.email.trim() !== "" ? "hightlight-edit" : ""}`}
        placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_EMAIL}
        onChange={handleCompanyEmail}
        // onBlur={validateCompanyEmail}
        value={formData.companyEmail}
    />
    {isCompanyEmailInvalid && formData.email && formData.email.trim() && (
        <div>
            <img id="login-error" className="login-error-edit" src={Globals.IMG.ERROR} alt="password error" />
            <label className='invalidCredential'>{Globals.ERROR_MESSAGES.REG_INVALID_EMAIL} {isCompanyEmailInvalid}</label>
        </div>
    )}
</div></div>
                        <div id="row-content" className="row-1-content-edit">
                        <div id="physical-address-holder-edit">
    <label id="physical-address-edit" className="physical-address-edit">{Globals.SIGNUP.COMPANY_ADDRESS}</label>
    <span tabIndex={6}>
        <TextArea
            id="addressTextArea"
            placeHolder={Globals.SIGNUP.ADDRESS_PLACEHOLDER}
            value={formData.businessAddress}
            textAreaInput={(value) => setFormData({ ...formData, businessAddress: value })}
            className={formData.businessAddress && formData.businessAddress.length > 0 ? "hightlight-edit" : ""}
        />
    </span>
</div>
                      <div id="country-holder-edit">
    <label id="country-edit" className="country-edit">{Globals.SIGNUP.COUNTRY}</label>
    <span tabIndex={23}><DropdownList options={allCountriesData} placeHolderValue={Globals.SIGNUP.COUNTRY_PLACEHOLDER} onSelect={handleCountry} selectClass={country && "hightlight-edit"} inputValue={formData.countryName}/></span>
</div>
<div id="provience-holder-edit">
    <label id="provience" className="provience-edit">{Globals.SIGNUP.PROVIENCE}</label>
    <span tabIndex={24}><DropdownList options={provincesList} placeHolderValue={Globals.SIGNUP.PROVIENCE_PLACEHOLDER} onSelect={handleProvince} selectClass={provience && "hightlight-edit"} inputValue={formData.provinceName} /></span>
</div>
                    </div>
                    <div id="row-content-edit" className="row-1-content-edit">
    
                    </div>
                </div>

            </div>
            <div>
            </div>
            <div>
                <span>
               
    <RegisterFooter
    onSubmit={handleUpdateOrConfirm}
    onCancelRegister={handleCancelEdit}
    isButtonEnabled={isFormValid}
    tabIndex1={26}
    tabIndex2={27}
/>
</span></div>
{isEditCanceled && (
    <div className='popup-bg'>
        <Popup
            title={Globals.EDIT_PROFILE.POPUP.cancel.TITLE}
            text={Globals.EDIT_PROFILE.POPUP.cancel.MESSAGE}
            negativeAction={navigateToCompanyProfile}
            negativeActionText={Globals.EDIT_PROFILE.POPUP.cancel.BUTTON_TEXT}
            onClose={() => setEditCanceled(false)}
            popupType={"abort"}
        />
    </div>
)}

{isEditFailed && (
    <div className='popup-bg'>
        <Popup
            title={Globals.PROFILE_UPDATE_ERROR_POPUP_TITLE}
            text={Globals.PROFILE_UPDATE_ERROR_POPUP_TEXT}
            normalAction={handleUpdate}
            normalActionText={Globals.EDIT_PROFILE.POPUP.retry.BUTTON_TEXT}
            popupType={"failed"}
            onClose={() => setEditFailed(null)}
        />
    </div>
)}

{isConfirmUpdatePopupVisible && (
    <div className='popup-bg'>
        <Popup
            title= {Globals.EDIT_PROFILE.POPUP.Update.BUTTON_TEXT}
            text={Globals.PROFILE_UPDATE_CONFIRMATION}
            normalAction={confirmUpdateAndCallApi}
            normalActionText={Globals.EDIT_PROFILE.POPUP.Update.BUTTON_TEXT}
            onClose={() => setIsConfirmUpdatePopupVisible(false)}
            popupType="confirm"
        />
    </div>
)}
{isLoading&&<ProgressLoader height={"50"} width={"50"} component={"edit"}/>}

        </div>
    )
}
export default EditCompany;